import data from "../../data/index.json";

export default function Work() {
  return (
    <section className="portfolio--section" id="work">
      <div className="portfolio--container-box">
        <div className="portfolio--container">
          <h2 className="skills--section--heading">OUR WORK</h2>
          <p>Let's let the results speak for themselves</p>
        </div>
      </div>
      <div className="portfolio--section--container">
        {data?.work?.map((item, index) => (
          <div className="portfolio--section--img">
            <img src={item.src} alt="Placeholder" />
          </div>
        ))}
      </div>
    </section>
  );
}
